(() => {
  const bootstrap = () => {
    window.KOMModules?.setupLanguageDropdown?.();
    window.KOMModules?.setupMobileMenu?.();
    window.KOMModules?.setupContactMap?.();
    window.KOMModules?.setupMuseumLightbox?.();
    window.KOMModules?.setupAsyncLeadForm?.();
    window.KOMModules?.setupHeroParallax?.();
    window.KOMModules?.setupScrollTopButton?.();
    window.KOMModules?.setupCookieConsent?.();
    window.KOMModules?.setupConsentTracking?.();
    window.KOMModules?.applyRevealAnimations?.();
    window.KOMModules?.setupYearStamp?.();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
    return;
  }

  bootstrap();
})();
